/* ModalLoadingComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ModalLoadingRenderer");

class ModalLoadingComponent extends EventEmitter {
    /**
     * Displays a loading veil with an optional spinner message and action buttons.
     * @param {object} [opts] - Optional parameters.
     * @param {string} [opts.message] - Message shown below the spinner.
     * @param {boolean} [opts.showHideButton] - Show a Hide button that auto-dismisses the veil on click.
     * @param {boolean} [opts.showAbortButton] - Show an Abort button (caller manages teardown).
     * @param {function} [opts.onAbort] - Called when the Abort button is clicked.
     * @param {string} [opts.abortLabel] - Label for the Abort button (defaults to "Abort").
     */
    constructor(opts) {
        super();
        this._message = _.get(opts, "message");
        this._showHideButton = _.get(opts, "showHideButton", false);
        this._showAbortButton = _.get(opts, "showAbortButton", false);
        this._abortLabel = _.get(opts, "abortLabel", "Abort");
        this._onAbort = _.get(opts, "onAbort");

        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get message() {
        return this._message;
    }

    get showHideButton() {
        return this._showHideButton;
    }

    get showAbortButton() {
        return this._showAbortButton;
    }

    get abortLabel() {
        return this._abortLabel;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
            this._userFeedbackContext = undefined;
            this._message = undefined;
            this._showHideButton = undefined;
            this._showAbortButton = undefined;
            this._abortLabel = undefined;
            this._onAbort = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    set "$teve.ui.context"(cntxt) {
        //jshint ignore:line
        this._userFeedbackContext = cntxt;
    }

    showProgress(msg) {
        this._renderer.showProgress(msg);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START PUBLIC ACTION METHODS             */
    /*******************************************/

    hide() {
        this._userFeedbackContext.reject({userRejected: true});
    }

    abort() {
        if (this._onAbort) {
            this._onAbort();
        }
    }

    /*******************************************/
    /* END PUBLIC ACTION METHODS               */
    /*******************************************/
}

module.exports = ModalLoadingComponent;
